import { useState, useEffect } from 'react';

const useScrollEffect = () => {
  const [scrollPosition, setScrollPosition] = useState(0);
  
  useEffect(() => {
    const handleScroll = () => {
      const position = window.scrollY;
      setScrollPosition(position);
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  // Calculate header styles based on scroll position
  const headerStyle = {
    backgroundPosition: `center ${scrollPosition * -1}px`,
    transition: 'min-height 0.3s ease'
  };
  
  return headerStyle;
};

export default useScrollEffect;